var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-form',{ref:"form",attrs:{"title":_vm.$t('message.workBench.body.setting.envVariable.title'),"list":_vm.script.params.configuration.runtime.env}})
}
var staticRenderFns = []

export { render, staticRenderFns }